/** Asks the host layout to raise the "onboarding pending" prompt. */
export const ONBOARDING_PENDING_MODAL_EVENT = 'open-onboarding-pending-modal';

/**
 * Fires the onboarding-pending prompt. The listener flips `detail.handled`,
 * so a synchronous false return means nothing is mounted to show it and the
 * caller should fall back to navigating.
 */
export const requestOnboardingPendingPrompt = (detail) => {
  if (
    typeof window === 'undefined' ||
    typeof window.dispatchEvent !== 'function' ||
    typeof window.CustomEvent !== 'function'
  ) {
    return false;
  }

  const payload = { handled: false, ...(detail || {}) };
  window.dispatchEvent(
    new window.CustomEvent(ONBOARDING_PENDING_MODAL_EVENT, { detail: payload }),
  );

  return payload.handled === true;
};

/**
 * Routes the customer to the next pending step of the paid-Direct journey.
 *
 * Order is onboarding → payment → agreement → risk (see
 * `getInvestmentEligibility`). Onboarding leads the journey and is prompted,
 * never forced; the payment, agreement and risk steps each raise a modal.
 */
export const applyDirectJourneyStepAction = (action, navigate, callbacks = {}) => {
  switch (action) {
    case 'payment':
      callbacks.onPayment?.();
      break;
    case 'agreement':
      callbacks.onAgreement?.();
      break;
    case 'onboarding':
      // Prompt before moving anyone — the onboarding screen is never opened
      // behind the customer's back.
      if (callbacks.onOnboardingRequired) {
        callbacks.onOnboardingRequired();
      } else if (!requestOnboardingPendingPrompt({ actionType: 'invest' })) {
        if (typeof navigate === 'function') {
          navigate('/onboarding/status');
        }
      }
      break;
    case 'risk':
      if (callbacks.onRiskRequired) {
        callbacks.onRiskRequired();
      } else {
        window.dispatchEvent(new Event('open-risk-assessment-modal'));
      }
      break;
    default:
      break;
  }
};
